import React, { FC } from 'react'

import { IconSocialLinkedinProps } from './IconSocialLinkedin.types'
import * as Styled from './styles/IconSocialLinkedin.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSocialLinkedin: FC<IconSocialLinkedinProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSocialLinkedinProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconSocialLinkedinProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M25.2 8h-.14a17.37 17.37 0 1 0 .14 0zM10 56h30v96H10zm105.82-2.5c-14.51 0-24.42 7.9-28.42 15.5H87V56H58v96h30v-47.6c0-12.5 2.44-24.7 18.27-24.7C121.8 79.7 122 94 122 105.2V152h30V99.3c0-25.9-5.65-45.8-36.18-45.8z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconSocialLinkedin
